module.exports = __webpack_public_path__ + "img/hero-slide-2.b856478d.svg";